import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';
import Connect from './Connect.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/whatsapp'),
    name: 'whatsapp_index',
    component: Index,
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/whatsapp/new'),
    name: 'whatsapp_connect',
    component: Connect,
    meta: { permissions: ['administrator'] },
  },
];
